import { IContentProperty } from "../Interfaces";

export class ComponentToSectionCommand {
  public Id: number = 0;
  public ContentComponentId: number = 0;
  public ComponentId: number = 0;
  public SectionId: number = 0;
  public PosX: number = 0;
  public PosY: number = 0;
  public Height: number = 0;
  public Width: number = 0;
  public ColIndex: number = 0;
  public PropertyValues: Array<IContentProperty> = [];
  public SiteId: string = "";
}